import { render, staticRenderFns } from "./I2FormPassword.vue?vue&type=template&id=2cfe9879&scoped=true"
import script from "./I2FormPassword.vue?vue&type=script&lang=js"
export * from "./I2FormPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe9879",
  null
  
)

export default component.exports